import React from 'react';
import { Box, Slider, Typography } from '@mui/material';
import { DateRange } from '../types/dashboard.types';
import { useDateRangeSlider } from '../hooks/useDateRangeSlider';
import { DateSliderSection } from '../Dashboard.styles';

interface DateRangeSliderProps {
  dateRange: DateRange | null;
  sliderValues: number[];
  onSliderChange: (event: Event, value: number | number[], activeThumb: number) => void;
  flightDates: string[];
  actionButton?: React.ReactNode;
}

export const DateRangeSlider: React.FC<DateRangeSliderProps> = ({
  dateRange,
  sliderValues,
  onSliderChange,
  flightDates,
  actionButton
}) => {
  const { marks, formatDateForSlider, getSliderDateRange } = useDateRangeSlider(dateRange, flightDates);
  const { start, end } = getSliderDateRange(sliderValues, flightDates);

  if (!dateRange) return null;

  return (
    <DateSliderSection>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Date Range
        </Typography>
        {actionButton && (
          <Box sx={{ minWidth: 'fit-content' }}>
            {actionButton}
          </Box>
        )}
      </Box>
      <Slider
        value={sliderValues}
        onChange={onSliderChange}
        valueLabelDisplay="auto"
        marks={marks}
        min={0}
        max={100}
        sx={{
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem',
          },
        }}
        valueLabelFormat={(value) => {
          const index = Math.floor((value / 100) * (flightDates.length - 1));
          const date = flightDates[index];
          return date ? formatDateForSlider(date) : '';
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant="body2" color="text.secondary">
          From: {formatDateForSlider(start, true)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          To: {formatDateForSlider(end, true)}
        </Typography>
      </Box>
    </DateSliderSection>
  );
};
